import type { Object3D } from '@anov/3d-core'
import { MathUtils, Vector3, gsap, use } from '@anov/3d-core'
import type { GrowOption, IGrowStyle } from './type'

// 向下掉落
export class GrowStyleDown implements IGrowStyle {
  private _objs: Array<Object3D>
  private _opt: GrowOption
  private _tl: gsap.core.Timeline
  private maxDistance: number

  constructor(objs: Array<Object3D>, opt: GrowOption) {
    this._objs = objs
    this._opt = opt
    this._tl = null// gsap.timeline()
    this.maxDistance = 0
  }

  // 对象初始化
  init(): void {
    this._tl = gsap.timeline()

    const max = this._opt.gapTime + this._opt.time
    // 统一为Vector3
    if (Array.isArray(this._opt.center))
      this._opt.center = new Vector3().fromArray(this._opt.center as number[])
    // 找到对象最远距离
    this._objs.map((obj) => {
      const distance = Math.abs(obj.position.distanceTo(this._opt.center as Vector3))
      obj.userData.growDistance = distance
      obj.userData.growY = obj.position.y
      if (distance > this.maxDistance)
        this.maxDistance = distance
    })

    this._objs.map((obj) => {
      // 计算排序延迟
      obj.userData.growDelay = MathUtils.lerp(0, max, obj.userData.growDistance / this.maxDistance)
      // 距离
      obj.position.y += this._opt.distance
      // 旋转
      this._opt.isRotate && obj.rotateY(MathUtils.degToRad(270))
      // 缩放
      this._opt.isScale && obj.scale.set(obj.scale.x * 0.1, obj.scale.y * 0.1, obj.scale.z * 0.1)
    })
  }

  in(): void {
    this._tl.clear()

    this._objs.map((obj) => {
      this._tl.add(gsap.to(obj.position, { y: obj.position.y - this._opt.distance, duration: this._opt.time, ease: this._opt.ease, delay: obj.userData.growDelay }), 0)
      if (this._opt.isRotate)
        this._tl.add(gsap.to(obj.rotation, { y: 0, duration: this._opt.time, ease: this._opt.ease, delay: obj.userData.growDelay }), 0)
      if (this._opt.isScale)
        this._tl.add(gsap.to(obj.scale, { x: 1, y: 1, z: 1, duration: this._opt.time, ease: this._opt.ease, delay: obj.userData.growDelay }), 0)
    })
    this._tl.play(0, false)
  }

  out(): void {
    this._tl.timeScale(this._opt.scale).reverse()
  }

  getTimeLine(): gsap.core.Timeline {
    return this._tl
  }
}